import { MAX_CHARACTER_EMAIL_VALIDATION } from "@/constants/common";
import { validator } from "@/utils/validator";

// Allowed email domains for RSO users (isUser === false)
const ALLOWED_RSO_EMAIL_DOMAINS = ["hopee.com.vn", "ro-hana.com"];

type UseGetUserSettingEmailSchemaProps = {
  currentEmail: string;
  /** If false (RSO user), only allow specific email domains */
  isUser: boolean;
};

export const useGetUserSettingEmailSchema = (props: UseGetUserSettingEmailSchemaProps) => {
  const { currentEmail, isUser } = props;

  return validator.object().shape({
    email: validator
      .string()
      .trim()
      .email()
      .max(MAX_CHARACTER_EMAIL_VALIDATION)
      .label("新しいメールアドレス")
      .required()
      .test("not-same-email", (value, ctx) => {
        if (value === currentEmail)
          return ctx.createError({ message: "新しいメールアドレスは現在のメールアドレスと同じです。別のメールアドレスを入力してください。" });
        return true;
      })
      .test("rso-email-domain", (value, ctx) => {
        // Only validate domain for RSO users (isUser === false)
        if (isUser) return true;

        if (!value) return true;

        const emailDomain = value.split("@")[1]?.toLowerCase();
        if (!emailDomain || !ALLOWED_RSO_EMAIL_DOMAINS.includes(emailDomain)) {
          return ctx.createError({
            message: '「irohana担当者」を選択した場合、メールアドレスは「iro-hana.com」または「hopee.com.vn」のドメインのみ登録可能です。',
          });
        }
        return true;
      }),
  });
};
